<template>
    <div>
        <header class="header_style nav-stacked affix-top" data-spy="affix" data-offset-top="1">
            <nav id="navigation_bar" class="navbar navbar-expand-lg">
                <div class="container p-3">
                    <div class="row header-row align-items-center">
                        <div class="col-md-3">
                            <div class="navbar-header">
                                <div class="logo">
                                    <a href="/ofertas"><img src="/assets/images/logo/logo_light2.png"
                                            alt="Logo-Redautos" /></a>
                                </div>
                                <button id="menu_slide" data-target="#navigation" aria-expanded="false"
                                    data-toggle="collapse" class="navbar-toggler" type="button">
                                    <i class="fa fa-bars"></i>
                                </button>
                            </div>
                        </div>
                        <div class="col-md-9" v-if="userAuth() != null">
                            <div class="header_wrap">
                                <div class="user_login m-2">
                                    <ul>
                                        <li class="dropdown">
                                            <a href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i
                                                    class="fa fa-user-circle" aria-hidden="true"></i>
                                                {{ usuario }}
                                                <i class="fa fa-angle-down" aria-hidden="true"></i></a>
                                            <ul class="dropdown-menu">
                                                <!-- <li>
                                                    <a
                                                        href="/mi_perfil"
                                                        >Mi Perfil</a
                                                    >
                                                </li>
                                                <li>
                                                    <a href="/mis_retomas"
                                                        >Mis Retomas</a
                                                    >
                                                </li>
                                                <li>
                                                    <a href="/reportar_vehiculo"
                                                        >Reportar Vehículo</a
                                                    >
                                                </li> -->
                                                <li>
                                                    <a href="/logout">Cerrar Sesión</a>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                                <div class="login_btn m-2">
                                    <a href="/admin/home" class="btn btn-xs uppercase" data-toggle="modal"
                                        data-dismiss="modal">Ingresar</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </header>
        <div class="modal fade" id="loginform">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h3 class="modal-title">Iniciar Sesión</h3>
                    </div>
                    <div class="modal-body">
                        <div class="login_wrap">
                            <div class="row justify-content-center">
                                <div class="col-md-8 col-sm-8">
                                    <form action="#" method="get">
                                        <div class="form-group">
                                            <input type="text" class="form-control" placeholder="Corre electronico" />
                                        </div>
                                        <div class="form-group">
                                            <input type="password" class="form-control" placeholder="Contraseña" />
                                        </div>
                                        <div class="form-group">
                                            <input type="submit" value="Ingresar" class="btn btn-block btn-dark " />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer text-center">
                        <p>
                            <a href="#forgotpassword" data-toggle="modal" data-dismiss="modal" class="text-muted">Olvidé mi
                                contraseña</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Permissions from "mixins/Permissions";
import config from "config/config.json";
export default {
    data() {
        return {
            logo:
                "https://brokcars-assets.s3.us-east-2.amazonaws.com" +
                config.logo_url,
            usuario: ''
        };
    },
    created() {
        this.get_usuario();
    },
    methods: {
        userAuth() {
            return Permissions.methods.$getIdUser();
        },
        get_usuario() {
            axios.get('/ajax/get_usuarios').then((response) => {
                var parsingUsuarios = _.orderBy(
                    response.data.usuarios,
                    ['name'],
                    ['asc'],
                )
                let users = parsingUsuarios.filter(usuario => usuario._id == this.userAuth());
                this.usuario = users[0].name;

            })
        },
    }
};
</script>

<style lang="scss" scoped></style>
